import React, { PureComponent } from 'react';
import Background from './landing/background';
import Links from './landing/links';
import Sections from './landing/sections';
import Events from './landing/events';
import News from './landing/news';
import Footer from './landing/footer/';
import axios from 'axios';
import appConstant, { externalServices } from '../../constants/app';
import { initGA } from '../components/baseComponents/Tracking';
import { InView } from 'react-intersection-observer'

class Landing extends PureComponent {
  state = {
    backgroundImage: '',
    logoImage: '',
    menuItems: [],
    loginUrl: '',
    footerContent: [],
    eventsList: {},
    newsList: [],
    isLoading: false,
  }

  componentDidMount () {
    this.fetch();
    this.fetchHeaderContent();
    this.fetchNav();
    initGA(externalServices.uacode)
  }

  fetchNav = () => {
    let url = `${appConstant.API_URL}/header`;
    axios.get(url)
      .then(res => {
        const logoImage = res.data.header.logo.image;
        const menuItems = res.data.header.menu_items;
        const loginUrl = res.data.header.login_url;
        const menuColor = res.data.header.menu_color;

        this.setState({
          logoImage,
          menuItems,
          loginUrl,
          menuColor
        });
      }).catch(err => {
        console.log(err);
      });
  }

  scrollHandleFunction = () => {

    const newsContainer = document.querySelector('.news-section');
    const newsContainerPosition = (newsContainer.offsetTop - newsContainer.scrollTop + newsContainer.clientTop + 400);
    
    const getCurrentTopPos = () => window.pageYOffset
    || document.documentElement.scrollTop
    || document.body.scrollTop
    || 0;

    const scrollHandle = (cb) => {
      window.addEventListener('scroll', () => {
        cb();
      });
    };

    let isLoading = false;

    scrollHandle(() => {
      const currentTopPos = getCurrentTopPos();
      console.log(currentTopPos);
      console.log(newsContainerPosition);
      if(currentTopPos > newsContainerPosition && !isLoading) {
        isLoading = true;
        axios.get(`${appConstant.API_URL}/news-feed`).then( ({ data }) => 
        this.populate('newsList', data.newsFeed)).catch( err => err);
      }
    });
  }


  fetchHeaderContent = () => {
    axios.all([
      axios.get(`${appConstant.API_URL}/background`),
      axios.get(`${appConstant.API_URL}/banner/current`),
    ])
      .then(axios.spread((
        backgroundRes,
        bannersRes,
      ) => {
        const backgroundImage = backgroundRes.data.background.image;
        const banners = bannersRes.data.banners;

        this.setState({
          backgroundImage,
          banners,
        });
      }))
      .catch(err => {
        console.log(err);
      });
  }

  populate = (key, value) => {
    this.setState({
      [key]: value
    });
  }

  fetch = () => {
    axios.get(`${appConstant.API_URL}/footer?from=front`).then( ({ data }) => 
      this.populate('footerContent', data.footer)).catch( err => err);
    axios.get(`${appConstant.API_URL}/event-feed`).then( ({ data }) => 
      this.populate('eventsList', data.eventFeed)).catch( err => err);
  }

  handleIntersection = (inView) => {
    console.log('Inview:', inView)
    if (!this.state.isLoading && inView) {
      axios.get(`${appConstant.API_URL}/news-feed`).then( ({ data }) => 
      this.populate('newsList', data.newsFeed)).catch( err => err);
      this.setState({
        isLoading: true,
      });
    }
  };

  render () {
    const {
      backgroundImage,
      banners,
      logoImage,
      menuItems,
      loginUrl,
      footerContent,
      eventsList,
      newsList,
      menuColor,
      visibility,
    } = this.state;

    return (
      <div className="landing-container">
        <Background
          backgroundImage={backgroundImage}
          banners={banners}
          logo={logoImage}
          menuItems={menuItems}
          loginUrl={loginUrl}
          menuColor={menuColor}
        />
        <Links />
        <Sections />
        <Events
          feed={eventsList}
        />
        <InView as="div" onChange={(inView, entry) => this.handleIntersection(inView)}>
          <News
            feed={newsList}
          />
        </InView>
        <Footer
          content={footerContent}
        />
      </div>
    );
  }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/app/screens/landing.js